const accordianElm = document.querySelectorAll(".toggle");
for (const elm of accordianElm) {
  elm.addEventListener('click', function(e) {

  e.preventDefault();

var innerElm = elm.closest('.accordion');
  if (elm.nextElementSibling.classList.contains("show")) {

    elm.nextElementSibling.classList.remove("show");
    elm.classList.add("toggle");
    
    } else {

   var innerElm = elm.closest('.accordion');
    const innerItem =  innerElm.querySelectorAll(":scope .accordion-item");
    for (let i = 0; i < innerItem.length; i++) {
      innerItem[i].querySelector(".inner").classList.remove("show");
      innerItem[i].querySelector("a").classList.add("toggle");
    }

   elm.nextElementSibling.classList.add("show");
    elm.classList.remove("toggle");

  }

  }); 
}